// extracted by mini-css-extract-plugin
module.exports = {"add-file-wrapper":"styles_add-file-wrapper__aWdpG","add-file-logo":"styles_add-file-logo__2Ffi1"};